import { Page } from "@/models/page-models/Page";

export const AccountsDashboard: Page = {
  "path": "accounts-dashboard",
  "name": "Dashboard",
  "props": {
    "data": {
      "title": "Dashboard",
      "printable": "FALSE",
      "url": "accounts-dashboard",
      "groups": [
        {
          "type": "tabs",
          "tabItems": [
            {
              "tabName": "Pending Payment Receipts",
              "bracketValueFormula": "{{fetchedData.invoicePayments.data.totalDocs}}",
              "rows": [
                {
                  "name": "1",
                  "pageItems": [
                    {
                      "type": "button",
                      "label": "Create Invoice Payment",
                      "onClick": [
                        {
                          "executionOrder": 1,
                          "pageFunction": {
                            "name": "openInvoicePaymentPage",
                            "type": "fnRedirect",
                            "arg1Key": "redirectUrl",
                            "arg1Value": "/create-payment-collection-receipt"
                          },
                          "name": "openInvoicePaymentPage"
                        }
                      ],
                      "disabled": "FALSE",
                      "color": "primary"
                    }
                  ]
                },
                {
                  "name": "2",
                  "pageItems": [
                    {
                      "type": "table",
                      "label": "My Invoice Payments",
                      "disabled": "FALSE",
                      "showIf": "{{fetchedData.invoicePayments.data.docs}}",
                      "items": "fetchedData.invoicePayments.data.docs",
                      "headers": [
                        {
                          "value": "_id",
                          "text": "Payment Id",
                          "type": "url",
                          "url": "/invoice-payment-receipt/{{__item._id}}"
                        },
                        {
                          "value": "customer.alias",
                          "text": "Customer",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,customerAlias,{{__item.customer}})"
                        },
                        {
                          "value": "createdBy.displayName",
                          "text": "Created By"
                        },
                        {
                          "value": "status",
                          "text": "Status"
                        },
                        {
                          "value": "amountReceived",
                          "text": "Amount",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,currency,{{{{__item.amountReceived}} || {{__item.expectedAmountReceived}}}})"
                        },
                        {
                          "value": "updatedAt",
                          "text": "Last Updated",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.updatedAt}})"
                        }
                      ],
                      "tableType": "static",
                      "selectableUniqueId": "_id",
                      "groupActions": [
                        {
                          "label": "Approve",
                          "disableIf": "fn(LOGICAL,fn(SUM,fn(LOGICAL,fn(LENGTH,{{__item}}),>,1),fn(LOGICAL,fn(CONCAT,',{{__item.0.status}},'),!==,'Submitted'),fn(LOGICAL,fn(SUBTRACT,{{__item.0.expectedAmountReceived}},{{__item.0.amountReceived}}),>,0.00001)),!==,0)",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "pageFunction": {
                                "name": "approvePayment",
                                "type": "fnSubmit",
                                "arg1Key": "apiUrl",
                                "arg1Value": "/api/v2/invoice-payment-receipt/{{__item._id}}/approve",
                                "arg2Key": "postData",
                                "arg2Value": "\"{}\"",
                                "arg3Key": "refreshPage",
                                "arg3Value": "TRUE"
                              },
                              "name": "approvePayment"
                            }
                          ]
                        },
                        {
                          "label": "Reject",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "pageFunction": {
                                "name": "rejectPayment",
                                "type": "fnSubmit",
                                "arg1Key": "apiUrl",
                                "arg1Value": "/api/v2/invoice-payment-receipt/{{__item._id}}/reject",
                                "arg2Key": "postData",
                                "arg2Value": "\"{}\"",
                                "arg3Key": "refreshPage",
                                "arg3Value": "TRUE"
                              },
                              "name": "rejectPayment"
                            }
                          ]
                        },
                        {
                          "label": "Retract",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "pageFunction": {
                                "name": "retractPayment",
                                "type": "fnSubmit",
                                "arg1Key": "apiUrl",
                                "arg1Value": "/api/v1/invoice-payment-receipt/{{__item._id}}/retract",
                                "arg2Key": "postData",
                                "arg2Value": "\"{}\"",
                                "arg3Key": "refreshPage",
                                "arg3Value": "TRUE",
                                "arg4Key": "requestMethod",
                                "arg4Value": "DELETE"
                              },
                              "name": "retractPayment"
                            }
                          ]
                        },
                        {
                          "label": "Edit",
                          "disableIf": "fn(LOGICAL,fn(LENGTH,{{__item}}),>,1)",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "pageFunction": {
                                "name": "openEditPaymentCollection",
                                "type": "fnRedirect",
                                "arg1Key": "redirectUrl",
                                "arg1Value": "update-payment-collection",
                                "arg2Key": "queryParams",
                                "arg2Value": "{\"receipt\":\"{{__item._id}}\"}"
                              },
                              "name": "openEditPaymentCollection"
                            }
                          ]
                        }
                      ],
                      "neverHideActionBar": true,
                      "pagination": {
                        "pageVariable": "fetchedData.invoicePaymentFilters.page",
                        "serverItemsLengthVariable": "fetchedData.invoicePayments.data.totalDocs",
                        "pageChangeFns": [
                          {
                            "executionOrder": 2,
                            "name": "getInvoicePayments"
                          }
                        ]
                      },
                      "height": "65vh"
                    }
                  ]
                }
              ]
            },
            {
              "tabName": "Pending Invoice",
              "bracketValueFormula": "fn(LENGTH,{{fetchedData.filteredLoadingManifests}})",
              "rows": [
                {
                  "name": "1",
                  "pageItems": [
                    {
                      "type": "label",
                      "label": "Select Loading Manifest to create Invoice"
                    }
                  ]
                },
                {
                  "name": "2",
                  "pageItems": [
                    {
                      "type": "table",
                      "label": "Loading Manifests",
                      "disabled": "FALSE",
                      "showIf": "{{fetchedData.filteredLoadingManifests}}",
                      "items": "fetchedData.filteredLoadingManifests",
                      "headers": [
                        {
                          "value": "__item._id",
                          "text": "LM#"
                        },
                        {
                          "value": "__item.createdAt",
                          "text": "LM Date",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.createdAt}})"
                        },
                        {
                          "value": "orders.0.factoryTicket.order.customer",
                          "text": "Customer",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,customerAlias,{{__item.orders.0.factoryTicket.order.customer}})"
                        },
                        {
                          "value": "__item.typeOfDelivery",
                          "text": "Type of Delivery"
                        },
                        {
                          "value": "__item.driverName",
                          "text": "Driver Name"
                        },
                        {
                          "value": "__item.plateNumber",
                          "text": "Plate No."
                        }
                      ],
                      "printable": false,
                      "tableType": "static",
                      "canDelete": false,
                      "selectableUniqueId": "_id",
                      "searchKeyOnSelected": "_id",
                      "onSelectedChange": [
                        {
                          "executionOrder": 1,
                          "name": "copySelectedLoadingManifest"
                        },
                        {
                          "executionOrder": 1,
                          "pageFunction": {
                            "name": "resetLoadingManifestArray",
                            "type": "fnCopyData",
                            "arg1Key": "sourceKey",
                            "arg2Key": "destinationKey",
                            "arg2Value": "formData.loadingManifests"
                          },
                          "name": "resetLoadingManifestArray"
                        },
                        {
                          "executionOrder": 2,
                          "name": "copyCustomerDetails"
                        },
                        {
                          "executionOrder": 2,
                          "pageFunction": {
                            "name": "copyCustomerId",
                            "type": "fnCopyData",
                            "arg1Key": "sourceKey",
                            "arg1Value": "fetchedData.selectedLoadingManifest.orders.0.factoryTicket.order.customer._id",
                            "arg2Key": "destinationKey",
                            "arg2Value": "formData.customer"
                          },
                          "name": "copyCustomerId"
                        },
                        {
                          "executionOrder": 2,
                          "pageFunction": {
                            "name": "pushLoadingManifestId",
                            "type": "fnPushToArray",
                            "arg1Key": "sourceVariable",
                            "arg1Value": "fetchedData.selectedLoadingManifest._id",
                            "arg2Key": "destinationVariable",
                            "arg2Value": "formData.loadingManifests"
                          },
                          "name": "pushLoadingManifestId"
                        },
                        {
                          "executionOrder": 2,
                          "pageFunction": {
                            "name": "copyLoadingManifestOrders",
                            "type": "fnCreateArray",
                            "arg1Key": "sourceVariable",
                            "arg1Value": "fetchedData.selectedLoadingManifest.orders",
                            "arg2Key": "destinationVariable",
                            "arg2Value": "fetchedData.lmOrders",
                            "arg3Key": "arrayTransformationFn",
                            "arg3Value": "getInvoiceOrderObject"
                          },
                          "name": "copyLoadingManifestOrders"
                        },
                        {
                          "executionOrder": 3,
                          "pageFunction": {
                            "name": "copyOrders",
                            "type": "fnCreateArray",
                            "arg1Key": "sourceVariable",
                            "arg1Value": "fetchedData.lmOrders",
                            "arg2Key": "destinationVariable",
                            "arg2Value": "formData.orders",
                            "arg3Key": "arrayTransformationFn",
                            "arg3Value": "getOrderObject"
                          },
                          "name": "copyOrders"
                        },
                        {
                          "executionOrder": 3,
                          "pageFunction": {
                            "name": "copyVatPercentage",
                            "type": "fnCopyData",
                            "arg1Key": "sourceFn",
                            "arg1Value": "getVatPercentage",
                            "arg2Key": "destinationKey",
                            "arg2Value": "fetchedData",
                            "arg3Key": "append",
                            "arg3Value": "TRUE",
                            "arg4Key": "destinationKeyType",
                            "arg4Value": "Object"
                          },
                          "name": "copyVatPercentage"
                        }
                      ],
                      "singleSelect": true
                    }
                  ]
                },
                {
                  "name": "3",
                  "pageItems": [
                    {
                      "type": "label",
                      "label": "Invoice Preview",
                      "showIf": "fn(LOGICAL,fn(LENGTH,{{formData.orders}},>,0)",
                      "class": "text-h5"
                    }
                  ]
                },
                {
                  "name": "4",
                  "pageItems": [
                    {
                      "type": "table",
                      "label": "Invoice Order Preview",
                      "disabled": "FALSE",
                      "showIf": "fn(LOGICAL,fn(LENGTH,{{formData.orders}},>,0)",
                      "items": "fetchedData.lmOrders",
                      "headers": [
                        {
                          "value": "__key",
                          "text": "#",
                          "type": "formula",
                          "formula": "fn(CONCAT,fn(SUM,{{__item.__key}},1),/,fn(LENGTH,{{fetchedData.lmOrders}}))"
                        },
                        {
                          "value": "__item.id._id",
                          "text": "Order #\\n# حزمة",
                          "type": "formula",
                          "formula": "{{__item.id.product._id}}\\n{{__item.id._id}}"
                        },
                        {
                          "value": "__item.id.product",
                          "text": "Description\\nالتفاصيل",
                          "type": "formula",
                          "formula": "fn(CONCAT,fn(HELPER_FN,productAlias,{{__item.id.product}}),fn(CONDITIONAL,fn(LOGICAL,{{__item.lineNumber}},>,0),fn(CONCAT, (,{{__item.lineNumber}},-,{{__item.itemNumber}},)),))",
                          "width": 130
                        },
                        {
                          "value": "__item.quantity",
                          "text": "Quantity\\nالكمية",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,kgToSellingUnitQuantity,{{__item.id}},{{__item.fg}},{{__item.quantity}})"
                        },
                        {
                          "value": "__item.FOC",
                          "text": "FOC",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,kgToSellingUnitQuantity,{{__item.id}},{{__item.fg}},{{__item.FOC}})"
                        },
                        {
                          "value": "__item.id.product.unit.unit2",
                          "text": "Unit\\nالوحدة",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,baseUnit,{{__item.id.product}})"
                        },
                        {
                          "value": "__item.unitPrice",
                          "text": "Unit Price SAR\\nسعر الوحدة  ر س"
                        },
                        {
                          "value": "__item.value",
                          "text": "Sub Total\\nالمجموع الفرعي",
                          "formula": "fn(HELPER_FN,currency,{{__item.value}})",
                          "align": "center"
                        },
                        {
                          "value": "vatRate",
                          "text": "VAT %\\nالضريبة %",
                          "type": "formula",
                          "formula": "{{fetchedData.vatPercent}} %"
                        },
                        {
                          "value": "vatValue",
                          "text": "VAT Value\\nقيمة الضريبة",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,currency,fn(MULTIPLY,{{__item.value}},{{fetchedData.vatPercent}},0.01))"
                        },
                        {
                          "value": "total",
                          "text": "Total + VAT\\nالمجموع + الضريبة",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,currency,fn(MULTIPLY,{{__item.value}},fn(SUM,100,{{fetchedData.vatPercent}}),0.01))"
                        },
                        {
                          "value": "additionalCharges",
                          "text": "Additional Charges",
                          "type": "formula",
                          "formula": "fn(CONDITIONAL,fn(LOGICAL,{{__item.additionalCharges}},>,0),fn(CONCAT,{{__item.additionalChargesType}},: ,fn(HELPER_FN,currency,{{__item.additionalCharges}})),N/A)"
                        }
                      ],
                      "tableType": "static",
                      "showActions": false,
                      "footer": {
                        "value": "{{fetchedData.selectedInvoice.data.orders.0.additionalCharges}}",
                        "id.product": "{{fetchedData.selectedInvoice.data.orders.0.additionalChargesType}}"
                      },
                      "hideFooter": "fn(LOGICAL,{{fetchedData.selectedInvoice.data.orders.0.additionalCharges}},>,0)"
                    }
                  ]
                },
                {
                  "name": "5",
                  "pageItems": [
                    {
                      "type": "custom_InvoiceTotal",
                      "variable": "formData.orders",
                      "label": "Sub Total",
                      "disabled": "FALSE",
                      "showIf": "fn(LOGICAL,fn(LENGTH,{{formData.orders}},>,0)",
                      "config": {
                        "totalFormula": "fn(MULTIPLY,fn(SUM,100,{{fetchedData.vatPercent}}),0.01,fn(KEYED_ARRAY_SUM,fn(SUM,{{__arrayItem.additionalCharges}},{{__arrayItem.value}}),{{formData.orders}}))",
                        "subTotalFormula": "fn(KEYED_ARRAY_SUM,fn(SUM,{{__arrayItem.additionalCharges}},{{__arrayItem.value}}),{{formData.orders}})",
                        "vatVariable": "{{fetchedData.vatPercent}}"
                      }
                    }
                  ]
                },
                {
                  "name": "6",
                  "pageItems": [
                    {
                      "type": "button",
                      "label": "Create Invoice",
                      "onClick": [
                        {
                          "executionOrder": 1,
                          "pageFunction": {
                            "name": "createInvoice",
                            "type": "fnSubmit",
                            "arg1Key": "apiUrl",
                            "arg1Value": "/api/v1/invoice/create",
                            "arg2Key": "postData",
                            "arg2Value": "formData",
                            "arg3Key": "storeResponse",
                            "arg3Value": "TRUE"
                          },
                          "name": "createInvoice"
                        },
                        {
                          "executionOrder": 2,
                          "pageFunction": {
                            "name": "showCreatedInvoiceSnackbar",
                            "type": "fnOpenSnackbar",
                            "color": "secondary",
                            "serverMessage": "Invoice Created, requesting ZATCA Clearance"
                          },
                          "executeIf": "fn(LOGICAL,{{__response.data._id}},>,0)",
                          "name": "showCreatedInvoiceSnackbar"
                        },
                        {
                          "executionOrder": 3,
                          "pageFunction": {
                            "name": "clearInvoice",
                            "type": "fnSubmit",
                            "arg1Key": "apiUrl",
                            "arg1Value": "/api/v1/e-invoicing/clear-invoice/{{__response.data._id}}?type=Invoice",
                            "arg2Key": "postData",
                            "arg2Value": "{}",
                            "arg3Key": "refreshPage",
                            "arg3Value": "TRUE",
                            "arg4Key": "requestMethod",
                            "arg4Value": "GET"
                          },
                          "executeIf": "fn(LOGICAL,{{__response.data._id}},>,0)",
                          "name": "clearInvoice"
                        }
                      ],
                      "disabled": "FALSE",
                      "showIf": "fn(LOGICAL,fn(LENGTH,{{fetchedData.lmOrders}},>,0)",
                      "color": "primary"
                    }
                  ]
                }
              ]
            }
          ]
        }
      ],
      "useMaxPageWidth": true
    },
    "initialFunctionsCalled": [
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "getCompanyDetails",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/staticdata?type=company-detail",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.companyDetails"
        },
        "name": "getCompanyDetails"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "copyDefaultInvoicePaymentFilters",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getDefaultInvoicePaymentFilters",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData.invoicePaymentFilters"
        },
        "name": "copyDefaultInvoicePaymentFilters"
      },
      {
        "executionOrder": 2,
        "name": "getInvoicePayments"
      },
      {
        "executionOrder": 2,
        "name": "getLoadingManifests"
      }
    ],
    "functions": [
      {
        "name": "getInvoicePayments",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v2/invoice-payment-receipts?status=Submitted&status=Pending",
        "arg2Key": "storeInVar",
        "arg2Value": "fetchedData.invoicePayments",
        "arg3Key": "postData",
        "arg3Value": "fetchedData.invoicePaymentFilters"
      },
      {
        "name": "getLoadingManifests",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v1/loadingmanifest/last10?hasInvoice=false",
        "arg2Key": "storeInVar",
        "arg2Value": "fetchedData.allLoadingManifests",
        "arg3Key": "fnsAfterSubmit",
        "arg3Value": "getFilteredLMs"
      },
      {
        "name": "copySelectedLoadingManifest",
        "type": "fnCopyData",
        "arg1Key": "sourceKey",
        "arg1Value": "__item.0",
        "arg2Key": "destinationKey",
        "arg2Value": "fetchedData.selectedLoadingManifest"
      },
      {
        "name": "getInvoiceOrderObject",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "order": "{{__selectedObject.order._id}}",
          "id": "{{__selectedObject.factoryTicket.order}}",
          "fg": "{{__selectedObject.fg.0}}",
          "quantity": "{{__selectedObject.quantity}}",
          "FOC": "{{__selectedObject.FOC}}",
          "unitPrice": "{{__selectedObject.order.unitPrice}}",
          "value": "fn(MULTIPLY,fn(HELPER_FN,kgToSellingUnitQuantity,{{__selectedObject.factoryTicket.order}},{{__selectedObject.fg.0}},{{__selectedObject.quantity}}),{{__selectedObject.order.unitPrice}})",
          "additionalCharges": "fn(CONDITIONAL,fn(LOGICAL,{{__selectedObject.order.additionalCharges}},>,0),{{__selectedObject.order.additionalCharges}},0)",
          "additionalChargesType": "{{__selectedObject.order.additionalChargesType}}",
          "itemNumber": "fn(CONDITIONAL,fn(NOT,{{__selectedObject.itemNumber}}),0,{{__selectedObject.itemNumber}})",
          "lineNumber": "fn(CONDITIONAL,fn(LOGICAL,{{__selectedObject.lineNumber}},>,0),{{__selectedObject.lineNumber}},0)"
        },
        "useFormula": true
      },
      {
        "name": "getOrderObject",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "id": "{{__selectedObject.order}}",
          "value": "{{__selectedObject.value}}",
          "quantity": "{{__selectedObject.quantity}}",
          "FOC": "{{__selectedObject.FOC}}",
          "itemNumber": "{{__selectedObject.itemNumber}}",
          "lineNumber": "{{__selectedObject.lineNumber}}",
          "additionalCharges": "{{__selectedObject.additionalCharges}}",
          "additionalChargesType": "{{__selectedObject.additionalChargesType}}"
        },
        "useFormula": true
      },
      {
        "name": "getFilteredLMs",
        "type": "fnCopyData",
        "arg1Key": "sourceFn",
        "arg1Value": "filterLM",
        "arg2Key": "destinationKey",
        "arg2Value": "fetchedData.filteredLoadingManifests"
      },
      {
        "name": "filterLM",
        "type": "fnFilterArray",
        "arg1Key": "sourceVariable",
        "arg1Value": "fetchedData.allLoadingManifests.data",
        "arg2Key": "formulaCondition",
        "arg2Value": "fn(LOGICAL,fn(LOGICAL,{{__item.invoice}},>,0),==,false)"
      },
      {
        "name": "getVatPercentage",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "vatPercent": "fn(CONDITIONAL,{{fetchedData.customerDetails.exportCustomer}},0,{{fetchedData.companyDetails.data.0.data.vatPercentage}})"
        },
        "useFormula": true
      },
      {
        "name": "copyCustomerDetails",
        "type": "fnCopyData",
        "arg1Key": "sourceKey",
        "arg1Value": "fetchedData.selectedLoadingManifest.orders.0.factoryTicket.order.customer",
        "arg2Key": "destinationKey",
        "arg2Value": "fetchedData.customerDetails"
      },
      {
        "name": "getDefaultInvoicePaymentFilters",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "page": "1"
        },
        "useFormula": true
      }
    ]
  },
  "forRole": "ACCOUNTING_MANAGER,ACCOUNTING_EXECUTIVE",
  "visible": true,
  "routerPriority": 100
}